import React from 'react';
import { motion } from 'framer-motion';

const Providers = () => {
  const providers = [
    {
      name: 'Spectrum Business',
      logo: 'Spectrum',
      description: 'Cable internet with extensive coverage',
      features: ['Up to 1 Gbps', 'Business support', 'Voice bundles']
    },
    {
      name: 'Optimum Business',
      logo: 'Optimum',
      description: 'Fiber and cable solutions',
      features: ['Up to 5 Gbps', '24/7 support', 'Cloud services']
    },
    {
      name: 'Verizon Business',
      logo: 'Verizon',
      description: 'Fiber and 5G business internet',
      features: ['Fiber & 5G', 'Advanced security', 'IoT solutions']
    },
    {
      name: 'RCN Business',
      logo: 'RCN',
      description: 'High-speed cable internet',
      features: ['Up to 1 Gbps', 'Affordable plans', 'Local support']
    },
    {
      name: 'EarthLink Business',
      logo: 'EarthLink',
      description: 'Multiple connection types',
      features: ['Fiber, Cable, DSL', 'Managed services', 'IT support']
    },
    {
      name: 'HughesNet Business',
      logo: 'HughesNet',
      description: 'Satellite internet solution',
      features: ['Available anywhere', 'Fast installation', 'Backup solution']
    },
    {
      name: 'Frontier Business',
      logo: 'Frontier',
      description: 'Fiber and DSL options',
      features: ['Fiber optic', 'Voice services', 'Business bundles']
    },
    {
      name: 'CenturyLink Business',
      logo: 'CenturyLink',
      description: 'Nationwide fiber network',
      features: ['High-speed fiber', 'Cloud solutions', '24/7 support']
    }
  ];

  return (
    <section id="providers" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Access Our Entire{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600">
              Provider Network
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We work with all major providers to get you the best rates and service options available
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {providers.map((provider, index) => (
            <motion.div
              key={provider.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.05 }}
              className="bg-white rounded-lg p-6 text-center hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-full h-16 flex items-center justify-center mb-4 bg-gray-100 rounded">
                <span className="text-lg font-bold text-gray-700">{provider.logo}</span>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">{provider.name}</h3>
              <p className="text-sm text-gray-600 mb-3">{provider.description}</p>
              <ul className="text-xs text-gray-500 space-y-1">
                {provider.features.map((feature, idx) => (
                  <li key={idx}>• {feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-center bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8"
        >
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Don't know which provider to choose?
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Our experts will analyze your business needs and compare all available providers in your area to find the perfect match
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Providers;